<template>
    <v-flex xl12>
        <h2>Imóveis<span class="text-title-header"> | Cadastro de imóveis</span></h2>
        <v-divider></v-divider>
        <br/>
        <router-view></router-view>
    </v-flex>
</template>
<script>
export default {
  name: 'medias',
  mounted: function () {
    this.$nextTick(function () {

    })
  }
}
</script>
